import { Component } from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import {detectPlatform, isMobileQQ} from "../../services/useragent";

/**
 * Generated class for the DiagnosisPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  segment: "diagnosis",
})
@Component({
  selector: 'page-diagnosis',
  templateUrl: 'diagnosis.html',
})
export class DiagnosisPage {

  ua = "";
  detectedPlatform = "";
  isMobileQQ = "";

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    this.ua = window.navigator.userAgent;
    this.detectedPlatform = detectPlatform();
    this.isMobileQQ = isMobileQQ() ? "yes" : "no";
    console.log('ionViewDidLoad DiagnosisPage');
  }

  clearAllDeviceData() {
    Object.keys(localStorage).forEach(key => {
      delete localStorage[key];
    })
    alert("OK");
  }

}



// WEBPACK FOOTER //
// ./src/pages/diagnosis/diagnosis.ts